import axios from '@/utils/api.request'
import { stringify } from 'qs';

export const queryChat=(data)=>{
    return axios.request({
        url: '/question',
        data,
        method: 'post'
    })
}

export const queryPoke=()=>{
    return axios.request({
        url: '/poke',
        method: 'get',
        // headers: {
        //     istts: true
        // }
    })
}

export const getNotice=(data)=>{
    return axios.request({
        url: '/notice-list',
        data,
        method: 'get'
    })
}

export const getRelate=(data)=>{
    return axios.request({
        url: '/search',
        data,
        method: 'post'
    })
}


export const userLog=(data)=>{
    return axios.request({
        url: '/log',
        data,
        method: 'post'
    })
}



export const setUser=(data)=>{
    return axios.request({
        url: '/set-userInfo',
        data,
        method: 'post'
    })
}


export const setPosition=(data)=>{
    return axios.request({
        url: '/set-position',
        data,
        method: 'post'
    })
}



export const queryComment=(data)=>{
    return axios.request({
        url: `/news/discuss-news?${stringify(data)}`,
        method: 'GET'
    })
}

export const discussNews=(data)=>{
    return axios.request({
        url: '/news/user-discuss',
        data,
        method: 'post'
    })
}

export const discussGuide=(data)=>{
    return axios.request({
        url: `/news/discuss-guide?${stringify(data)}`,
        method: 'GET'
    })
}


//其它新闻

export const discussNewsOther=(data)=>{
    return axios.request({
        url: `/news/sim-news?${stringify(data)}`,
        method: 'get'
    })
}


/*热点新闻*/

export const getHotTopic=()=>{
    return axios.request({
        url: '/news/hot-topic',
        method: 'get'
    })
}


export const getHotTopicDesc=(data)=>{
    return axios.request({
        url: `/news/hot-topic-desc?${stringify(data)}`,
        method: 'get'
    })
}

export const getHotTopicNews=(data)=>{
    return axios.request({
        url: `/news/hot-topic-news?${stringify(data)}`,
        method: 'get'
    })
}



export const getHotNews=()=>{
    return axios.request({
        url: '/news/hot-news',
        method: 'get'
    })
}

export const getSceneCommon=()=>{
    return axios.request({
        url: '/news/scene-common',
        method: 'get'
    })
}


export const getSceneMultiProcess=()=>{
    return axios.request({
        url: '/scene-multi-process',
        method: 'get'
    })
}


/**
 * 多流程
 * @param data
 */
export const queryMultiProgress=(data)=>{
    return axios.request({
        url: '/multi-process',
        data,
        method: 'post'
    })
}

/**
 * 旅游场景
 */
//选择查询数据源
export const queryTourism=()=>{
    return axios.request({
        url: '/tourism/click-data',
        method: 'get'
    })
}


//推荐景点
export const queryTourSight=(data)=>{
    console.info('data',data)
    return axios.request({
        url: `/tourism/sight-list`,
        data,
        method: 'post'
    })
}

//获取景点详情

export const queryTourDetail=(data)=>{
    return axios.request({
        url: `/tourism/sight-detail?${stringify(data)}`,
        method: 'get'
    })
}

//我想去玩
export const queryTourGo=(data)=>{
    return axios.request({
        url: `/tourism/sight-go?${stringify(data)}`,
        method: 'get'
    })
}

/*不感兴趣*/

export const queryTourCommon=()=>{
    return axios.request({
        url: `/tourism/scene-common`,
        method: 'get'
    })
}

/*获取服务器时间*/

export const getServiceTime=()=>{
    return axios.request({
        url: '/getTime',
        method: 'get'
    })
}

/*获取新闻下一页*/

export const getNextBatch=()=>{
    return axios.request({
        url: '/news/next-batch',
        method: 'get'
    })
}

/*获取机器人属性配置*/

export const getRobotConfig=()=>{
    return axios.request({
        url: '/property/config',
        method: 'get'
    })
}

// 上传音频之后再请求
export const sendAudiorecorderQuestion=(data)=>{
    // console.log("sendAudiorecorder=====",data)
    return axios.request({
        url: '/speech',
        data,
        method: 'post'
    })
}
